/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Logging_Volume_OffInputs */

const en_us2_workout_logging_volume_off = /** @type {(inputs: Workout_Logging_Volume_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Off`)
};

const pt_br2_workout_logging_volume_off = /** @type {(inputs: Workout_Logging_Volume_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mudo`)
};

const es_419_workout_logging_volume_off = /** @type {(inputs: Workout_Logging_Volume_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Silencio`)
};

const pt_pt2_workout_logging_volume_off = /** @type {(inputs: Workout_Logging_Volume_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem som`)
};

const fr_fr2_workout_logging_volume_off = /** @type {(inputs: Workout_Logging_Volume_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muet`)
};

const de_de2_workout_logging_volume_off = /** @type {(inputs: Workout_Logging_Volume_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aus`)
};

const it_it2_workout_logging_volume_off = /** @type {(inputs: Workout_Logging_Volume_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muto`)
};

/**
* | output |
* | --- |
* | "Off" |
*
* @param {Workout_Logging_Volume_OffInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_volume_off = /** @type {((inputs?: Workout_Logging_Volume_OffInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Volume_OffInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_volume_off(inputs)
	if (locale === "es-419") return es_419_workout_logging_volume_off(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_volume_off(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_volume_off(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_volume_off(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_volume_off(inputs)
	return en_us2_workout_logging_volume_off(inputs)
});
export { workout_logging_volume_off as "workout-logging.volume_off" }